import { combineReducers } from 'redux'
import { reducerTypeWrapper } from '@labrav/common'

import { reducer as ProductsListingReducer } from '../modules/productsListing/reducer'
import { reducer as BuyersReducer } from '../modules/buyers/reducer'
import { reducer as BuyerContractsReducer } from '../modules/buyerContracts/reducer'
import { reducer as BuyerContactsReducer } from '../modules/buyerContacts/reducer'
import { reducer as BuyerRevenuesReducer } from '../modules/buyerRevenues/reducer'
import { reducer as BuyerMeteringsReducer } from '../modules/buyerMeterings/reducer'
import { reducer as FlyoutOverviewReducer } from '../modules/flyoutOverview/reducer'
import { reducer as UsageMeteringReducer } from '../modules/usageMetering/reducer'
import { reducer as RevenueInsightsV2Reducer } from '../modules/revenueInsightsV2/reducer'
import { reducer as FlyoutProductInCreationReducer } from '../modules/addEditProduct/reducer'
import { reducer as FlyOutMigrationProductsInfoReducer } from '../modules/addEditProduct/productsInfo/reducer'
import { reducer as SubscriptionsReducer } from '../modules/subscription/reducer'
import { reducer as ModalSubscriptionsReducer } from '../modules/modalSubscription/reducer'
import { reducer as PrivateOffersReducer } from '../modules/privateOffer/reducer'
import { reducer as ChannelPartnerPrivateOffersReducer } from '../modules/channelPartnerPrivateOffer/reducer'
import { reducer as ResaleAuthorizationsCreationReducer } from '../modules/resaleAuthorization/reducer'
import { reducer as ResellerReducer } from '../modules/reseller/reducer'
import { reducer as ReceivedResellerAuthorizationReducer } from '../modules/receivedResellerAuthorization/reducer'
import { reducer as StorefrontReducer } from '../modules/storefront/reducer'
import { reducer as ListingCardCreationReducer } from '../modules/storefront/listingCardCreation/reducer'
import { reducer as TemplateCreationReducer } from '../modules/storefront/templateCreation/reducer'
import { reducer as ButtonCreationReducer } from '../modules/storefront/buttonCreation/reducer'
import { reducer as StorefrontMetricsReducer } from '../modules/storefrontMetrics/reducer'
import { reducer as FlyoutRevenueInsightsReducer } from '../modules/revenueInsights/reducer'
import { reducer as RevenueDisbursementSidePanelReducer } from '../modules/revenueInsights/revenueInsightsDisbursementPanel/reducer'
import { reducer as CombinedFormReducer } from '../modules/combinedForm/reducer'
import { reducer as MicrosoftCombinedFormReducer } from '../modules/microsoftCombinedForm/reducer'
import { reducer as FreeTrialsReducer } from '../modules/freeTrials/reducer'
import { reducer as ContractsListingReducer } from '../modules/contractsListing/reducer'
import { reducer as ProductListingFiltersReducer } from '../modules/productListingFilter/reducer'
import { reducer as FlyOutOnboardingReducer } from '../modules/flyOutOnboarding/reducer'
import { reducer as MarketplaceMappingManagerReducer } from '../modules/marketplaceMappingManager/reducer'
import { reducer as CPPOAdminReducer } from '../admin/modules/resaleAuthorizations'
import { reducer as CPPOResellerAgreementReducer } from '../modules/cppoResellerAgreement/reducer'

export const marketplaceReducerMap = {
  productsListing: combineReducers({
    AWS: reducerTypeWrapper('AWS', ProductsListingReducer),
    AZURE: reducerTypeWrapper('AZURE', ProductsListingReducer),
    GCP: reducerTypeWrapper('GCP', ProductsListingReducer),
    REDHAT: reducerTypeWrapper('REDHAT', ProductsListingReducer),
  }),
  BuyersOverView: BuyersReducer,
  BuyerContracts: BuyerContractsReducer,
  BuyerContacts: BuyerContactsReducer,
  BuyerRevenues: BuyerRevenuesReducer,
  BuyerMeterings: BuyerMeteringsReducer,
  flyoutOverview: FlyoutOverviewReducer,
  usageData: UsageMeteringReducer,
  revenueInsightsV2: RevenueInsightsV2Reducer,
  flyoutProductInCreation: FlyoutProductInCreationReducer,
  flyOutMigrationProductsInfo: FlyOutMigrationProductsInfoReducer,
  subscriptions: SubscriptionsReducer,
  modalSubscription: ModalSubscriptionsReducer,
  privateOffers: PrivateOffersReducer,
  channelPartnerPrivateOffers: ChannelPartnerPrivateOffersReducer,
  resaleAuthorizationsInCreation: ResaleAuthorizationsCreationReducer,
  resellers: ResellerReducer,
  receivedResellerAuthorization: ReceivedResellerAuthorizationReducer,
  storefrontData: StorefrontReducer,
  listingCardInCreation: ListingCardCreationReducer,
  templateCreation: TemplateCreationReducer,
  buttonCreation: ButtonCreationReducer,
  storefrontMetricsData: StorefrontMetricsReducer,
  revenueInsights: combineReducers({
    daily: reducerTypeWrapper('daily', FlyoutRevenueInsightsReducer),
    monthly: reducerTypeWrapper('monthly', FlyoutRevenueInsightsReducer),
    cloudDisbursement: reducerTypeWrapper(
      'cloudDisbursement',
      FlyoutRevenueInsightsReducer
    ),
    disbursement: reducerTypeWrapper(
      'disbursement',
      FlyoutRevenueInsightsReducer
    ),
  }),
  revenueDisbursementSidePanel: RevenueDisbursementSidePanelReducer,
  freeTrials: FreeTrialsReducer,
  combinedFormInCreation: CombinedFormReducer,
  microsoftCombinedForm: MicrosoftCombinedFormReducer,
  contractsListing: ContractsListingReducer,
  productListingFilters: ProductListingFiltersReducer,
  flyOutOnboarding: FlyOutOnboardingReducer,
  marketplaceMappingManager: MarketplaceMappingManagerReducer,
  cppoReseller: CPPOAdminReducer,
  cppoResellerAgreement: CPPOResellerAgreementReducer,
} as const

export const rootReducer = combineReducers(marketplaceReducerMap)

export type MarketplaceRootState = ReturnType<typeof rootReducer>
